import { isEmpty } from './generic_utils';

export const isEffectivelyEmpty = (value) => {
  return isEmpty(value?.trim());
};

export const stripNonAlpha = (value) => {
  if (!value) {
    return value;
  }
  return value.replace(/[^a-z0-9]/gi, '');
};
